exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreementSection__container___3H6Qa {\n  padding-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"container": "agreementSection__container___3H6Qa"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/agreementSection.scss
// module id = 4524
// module chunks = 6